import { Button, Col, Collapse, Row, Spinner } from "react-bootstrap";
import React, { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Icon } from "@lomarengas/design-system";
import BookingRowsTable from "./BookingRowsTable";
import { useAuthUser } from "../../features/auth/authHooks";
import {
  getAccommodationsCalendarBookingsAsync,
  getBookingsCreatedInSevenDays,
  getBookingsStartingInSevenDays,
  selectAccommodationsBookingItems,
  selectBookingItemsCreatedInSevenDays,
  selectBookingItemsStartingInSevenDays,
  selectBookingsCreatedInSevenDaysStatus,
  selectBookingsStartingInSevenDaysStatus,
} from "./bookingsSlice";
import { LOADING_STATUS } from "../../common/constants";

const BookingsCreatedInSevenDays = () => {
  const dispatch = useAppDispatch();
  const { ownerAccountId } = useAuthUser();
  const { isOwnerUser } = useAuthUser();
  const [
    bookingsCreatedInSevenDayBookingsToLoad,
    setBookingsCreatedInSevenDayBookingsToLoad,
  ] = useState(false);

  const bookingsItemsCreatedInSevenDays = useAppSelector((state) =>
    selectBookingItemsCreatedInSevenDays(state),
  );
  const bookingsItemsCreatedInSevenDaysStatus = useAppSelector((state) =>
    selectBookingsCreatedInSevenDaysStatus(state),
  );
  const initFetch = () => {
    if (!bookingsCreatedInSevenDayBookingsToLoad) {
      return;
    }
    // Fetch bookings for this ownerid for bookings that were created in past 7 days
    dispatch(getBookingsCreatedInSevenDays());
  };
  useEffect(() => {
    initFetch();
  }, [bookingsCreatedInSevenDayBookingsToLoad]);

  return (
    <>
      <Button
        onClick={() =>
          setBookingsCreatedInSevenDayBookingsToLoad(
            !bookingsCreatedInSevenDayBookingsToLoad,
          )
        }
        aria-controls="example-collapse-text"
        aria-expanded={bookingsCreatedInSevenDayBookingsToLoad}
        variant="outline-blue"
        className="w-100 mt-16"
      >
        <Icon Name="chevron-expand" /> Näytä 7 päivän sisällä luodut varaukset
      </Button>

      {bookingsCreatedInSevenDayBookingsToLoad && (
        <>
          {bookingsItemsCreatedInSevenDaysStatus === LOADING_STATUS.LOADING ? (
            <div className="d-flex gap-16 align-items-center mt-16">
              <Spinner animation="border" />
              <span>Ladataan varauksia…</span>
            </div>
          ) : bookingsItemsCreatedInSevenDaysStatus === LOADING_STATUS.IDLE &&
            bookingsItemsCreatedInSevenDays != null &&
            bookingsItemsCreatedInSevenDays.length > 0 ? (
            <BookingRowsTable
              bookings={bookingsItemsCreatedInSevenDays}
              clearAllPastBookings={true}
              showCottageName={true}
              onICalSaved={() => dispatch(getBookingsCreatedInSevenDays())}
            />
          ) : (
            <p className="mt-16">Ei varauksia luotu 7 päivän aikana.</p>
          )}
        </>
      )}
    </>
  );
};

export default BookingsCreatedInSevenDays;
